/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_Dev_OnlyInputs */

const th_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การทดลองประชุมนี้ใช้ได้ในสภาพแวดล้อมพัฒนาเท่านั้น`)
};

const en_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This meeting experiment is available in development only.`)
};

const ja_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このミーティング実験は開発環境でのみ利用できます。`)
};

const zh_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此会议实验仅存在于开发环境。`)
};

const es_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este experimento de reuniones solo está disponible en desarrollo.`)
};

const pt_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este experimento de reunião está disponível apenas em desenvolvimento.`)
};

const id_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percobaan pertemuan ini hanya ada di pengembangan.`)
};

const fr_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette expérimentation de réunion n’est disponible qu’en développement.`)
};

const tl_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sa development lamang umiiral ang eksperimentong miting na ito.`)
};

const vi_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử nghiệm họp này chỉ có trong bản phát triển.`)
};

const ko_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 회의 실험은 개발 환경에만 있습니다.`)
};

const de_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Meeting-Experiment gibt es nur in der Entwicklung.`)
};

const ru_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот эксперимент со встречами есть только в разработке.`)
};

const tr_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu toplantı denemesi yalnızca geliştirmede var.`)
};

const it_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo esperimento sulle riunioni esiste solo in sviluppo.`)
};

const pl_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten eksperyment ze spotkaniami istnieje tylko w wersji deweloperskiej.`)
};

const uk_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей експеримент зі зустрічами є лише в розробці.`)
};

const hi_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह बैठक प्रयोग केवल डेवलपमेंट में है।`)
};

const ar_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجربة الاجتماع هذه موجودة في بيئة التطوير فقط.`)
};

const ms_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksperimen mesyuarat ini hanya wujud dalam pembangunan.`)
};

const bn_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই সভা পরীক্ষাটি কেবল ডেভেলপমেন্টে আছে।`)
};

const zh_tw2_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個會議實驗僅存在於開發環境。`)
};

const zh_hk2_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個會議實驗僅存在於開發環境。`)
};

const ur_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ ملاقات کا تجربہ صرف ڈویلپمنٹ میں ہے۔`)
};

const fa_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این آزمایش جلسه فقط در محیط توسعه هست.`)
};

const sw_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaribio hili la mkutano lipo kwenye mazingira ya uendelezaji pekee.`)
};

const nl_meeting_test_dev_only = /** @type {(inputs: Meeting_Test_Dev_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit gespreksexperiment bestaat alleen in ontwikkeling.`)
};

/**
* | output |
* | --- |
* | "This meeting experiment is available in development only." |
*
* @param {Meeting_Test_Dev_OnlyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_dev_only = /** @type {((inputs?: Meeting_Test_Dev_OnlyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_Dev_OnlyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_dev_only(inputs)
	if (locale === "ja") return ja_meeting_test_dev_only(inputs)
	if (locale === "zh") return zh_meeting_test_dev_only(inputs)
	if (locale === "es") return es_meeting_test_dev_only(inputs)
	if (locale === "pt") return pt_meeting_test_dev_only(inputs)
	if (locale === "id") return id_meeting_test_dev_only(inputs)
	if (locale === "fr") return fr_meeting_test_dev_only(inputs)
	if (locale === "tl") return tl_meeting_test_dev_only(inputs)
	if (locale === "vi") return vi_meeting_test_dev_only(inputs)
	if (locale === "ko") return ko_meeting_test_dev_only(inputs)
	if (locale === "de") return de_meeting_test_dev_only(inputs)
	if (locale === "ru") return ru_meeting_test_dev_only(inputs)
	if (locale === "tr") return tr_meeting_test_dev_only(inputs)
	if (locale === "it") return it_meeting_test_dev_only(inputs)
	if (locale === "pl") return pl_meeting_test_dev_only(inputs)
	if (locale === "uk") return uk_meeting_test_dev_only(inputs)
	if (locale === "hi") return hi_meeting_test_dev_only(inputs)
	if (locale === "ar") return ar_meeting_test_dev_only(inputs)
	if (locale === "ms") return ms_meeting_test_dev_only(inputs)
	if (locale === "bn") return bn_meeting_test_dev_only(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_dev_only(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_dev_only(inputs)
	if (locale === "ur") return ur_meeting_test_dev_only(inputs)
	if (locale === "fa") return fa_meeting_test_dev_only(inputs)
	if (locale === "sw") return sw_meeting_test_dev_only(inputs)
	if (locale === "nl") return nl_meeting_test_dev_only(inputs)
	return en_meeting_test_dev_only(inputs)
});